// extracted by mini-css-extract-plugin
module.exports = {"draftUploadHeading":"DraftUpload_draftUploadHeading__fjgBX"};